import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UsersService } from 'app/modules/user-management/services/users.service';

@Component({ standalone: false,
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  private permSub: Subscription;

  constructor(protected usersService: UsersService, private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.permSub = this.usersService.getMessage().subscribe(() => {
      this.cd.detectChanges();
    });
  }

  ngOnDestroy() {
    this.permSub?.unsubscribe();
  }
}
